import { Attachment } from '@/models/message.model';
import { Response } from '@/models/generic-paging.model';

export function convertArrayToApiParams(params?: Record<string, string | number | Array<string | number>>) {
  for (const property in params) {
    if (Array.isArray(params[property])) {
      params[property] = (params[property] as Array<string | number>).join(',');
    }
  }
  return params;
}

export function nextPageParam<T>(lastPage: Response<T>) {
  return lastPage.pager.total_entries - lastPage.pager.current_page * lastPage.pager.entries_per_page > 0
    ? lastPage.pager.current_page + 1
    : undefined;
}
export async function convertFiletoBlobAndDownload(file: Attachment) {
  const a = document.createElement('a');
  let url;
  if (file.content_type === 'application/pdf') {
    a.href = file.url;
  } else {
    const blob = await fetch(file.url).then(r => r.blob());
    url = URL.createObjectURL(blob);
    a.href = url;
  }
  a.style.display = 'none';
  a.download += file.filename;
  a.target = '_blank';
  document.body.appendChild(a);
  a.click();
  if (url) window.URL.revokeObjectURL(url);
  a.remove();
}

export function isOpenedInSafari() {
  return navigator.userAgent.indexOf('Safari') >= 0;
}
